import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Widgets from "./Widgets";
import { openSearch } from "../../state/modules/search";
import {
  getTotalQuantity,
  getUpdated,
  getBagFromSDK
} from "../../state/modules/miniBag";
import { isLoggedIn, getIsReconsentRequired } from "../../state/modules/user";
import {
  hasSavedItems,
  getSavedItemsFromSDK
} from "../../state/modules/savedItems";
import { getViewport } from "../../state/modules/layout";

import {
  getDefaultLanguage,
  getCountryCode,
  getStoreCode,
  getKeyStoreDataversion,
  getDefaultStoreUrl
} from "../../state/modules/regionalStore";

import { isFeatureActive } from "../../state/modules/features";

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openSearch,
      getSavedItemsFromSDK,
      getBagFromSDK
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    isLoggedIn: isLoggedIn(state),
    hasSavedItems: hasSavedItems(state),
    noOfBagItems: getTotalQuantity(state),
    storeCode: getStoreCode(state),
    lang: getDefaultLanguage(state),
    countryCode: getCountryCode(state),
    keyStoreDataversion: getKeyStoreDataversion(state),
    defaultStoreUrl: getDefaultStoreUrl(state),
    isUpdated: getUpdated(state),
    isReconsentRequired: getIsReconsentRequired(state),
    viewport: getViewport(state),
    myAccountToggle: isFeatureActive(state, "stc-myaccount-dropdown"),
    miniBagToggle: isFeatureActive(state, "stc-minibag-dropdown")
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Widgets);



// WEBPACK FOOTER //
// ./template/components/Widgets/index.js